import { Theme } from "@mui/material";
import { SegmentCustomersStatisticView } from "@tiny/api";
import { formatPercent } from "@tiny/components/src/utils/formatUtils";

export function createSegmentsChartData(
  segments: SegmentCustomersStatisticView[] | undefined,
  theme: Theme
) {
  if (!segments) {
    return [];
  }

  const colors = [
    theme.palette.primary.lighter,
    theme.palette.purple.light,
    theme.palette.blue.lighter,
    theme.palette.red.light,
    theme.palette.fuchsia.light,
    theme.palette.green.light,
    theme.palette.yellow.light,
  ];

  const total =
    segments?.reduce(
      (total, item) => total + (item.numberOfCustomers || 0),
      0
    ) || 0;

  return segments
    ?.filter((item) => item)
    ?.sort((a, b) => {
      if (b?.numberOfCustomers && a?.numberOfCustomers) {
        return b?.numberOfCustomers - a?.numberOfCustomers;
      }

      return -1;
    })
    ?.map(({ name, numberOfCustomers }, index) => {
      const value = numberOfCustomers || 0;
      let percent = formatPercent(0);
      if (total === 0) {
        percent = formatPercent(0);
      } else if (numberOfCustomers) {
        percent = formatPercent((100 * value) / total);
      }
      return {
        id: index,
        color: colors[index] || colors[3],
        label: name,
        value,
        percent,
      };
    });
}
